import { FeatureFlagResolver } from '@types';

export const arrayItemExists = (arr1: (string | number)[], arr2: (string | number)[]) => {
	let found = false;
	for (let i=0, l=arr2.length; i<l; ++i) {
		if (arr1.includes(arr2[i])) found = true;
	}
	return found;
}

export const resolveFromUnion = (
	test: string | number | string[] | number [] | boolean,
	resolve: string | number | string[] | number [] | boolean
) => {
	if (
		typeof test === 'boolean' &&
		typeof resolve === 'boolean' &&
		test && resolve
	) return true;
	if (
		typeof test === 'string' &&
		typeof resolve === 'string' &&
		test === resolve
	) return true;
	if (
		typeof test === 'number' &&
		typeof resolve === 'number' &&
		test === resolve
	) return true;
	if (
		Array.isArray(test) &&
		Array.isArray(resolve) &&
		arrayItemExists(resolve, test)
	) return true;
	if (
		Array.isArray(test) &&
		(typeof resolve === 'string' || typeof resolve === 'number') &&
		(test as (string | number)[]).includes(resolve)
	) return true;
	if (
		(typeof test === 'string' || typeof test === 'number') &&
		Array.isArray(resolve) &&
		(resolve as (string | number)[]).includes(test)
	) return true;
	return false;
}

export const resolveFlag = (
	flag: FeatureFlagResolver | boolean,
	test?: FeatureFlagResolver
) => {
	if (typeof flag === 'boolean') return flag;
	if (flag as FeatureFlagResolver && test) {
		const fResolver = Object.entries(flag);
		let isOn = false;
		for (let i=0, l=fResolver.length; i<l; ++i) {
			const [key, resolve] = fResolver[i];
			if (key === 'env' && test.env) {
				if (
					typeof test.env === 'string' &&
					typeof resolve === 'string' &&
					resolve === test.env
				) {
					isOn = true;
					break;
				}
				if (
					typeof test.env === 'string' &&
					Array.isArray(resolve) &&
					(resolve as string[]).includes(test.env)
				) {
					isOn = true;
					break;
				}
				if (
					Array.isArray(test.env) &&
					typeof resolve === 'string' &&
					(test.env as string[]).includes(resolve)
				) {
					isOn = true;
					break;
				}
				if (
					Array.isArray(test.env) &&
					Array.isArray(resolve) &&
					arrayItemExists((resolve as string[]), test.env)
				) {
					isOn = true;
					break;
				}
			}
			if (key === 'UserID' && test.UserID) {
				const resolved = resolveFromUnion(test.UserID, resolve);
				if (resolved) {
					isOn = true;
					break;
				}
			}
			if (key === 'ShipperID' && test.ShipperID) {
				const resolved = resolveFromUnion(test.ShipperID, resolve);
				if (resolved) {
					isOn = true;
					break;
				}
			}
			if (key === 'CarrierID' && test.CarrierID) {
				const resolved = resolveFromUnion(test.CarrierID, resolve);
				if (resolved) {
					isOn = true;
					break;
				}
			}
			if (
				key === 'isAdmin' &&
				test.isAdmin !== undefined &&
				resolve === test.isAdmin
			) {
				isOn = true;
				break;
			}
		}
		return isOn;
	}
	return false;
}